import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const fetchCount = async () => {
  const { data } = await api.get('/hall-pass/count');
  return data.count;
};

export const sendHeartbeat = async () => {
  const { data } = await api.post('/hall-pass/heartbeat');
  return data.count;
};

export const submitLead = async (payload) => {
  const { data } = await api.post('/hall-pass/leads', payload);
  return data;
};

export const fetchLeads = async () => {
  const { data } = await api.get('/hall-pass/leads');
  return data;
};
